import { siteInfo } from "@/mocks/site";

const POSITIONING = [
  {
    icon: "ri-focus-3-line",
    title: "网站定位",
    desc: "不做信息最全的娱乐站，只做把一件事讲透的追踪站。我们愿意为一条线索花上几天，也不愿意同时铺开一百条没下文的爆料。",
  },
  {
    icon: "ri-seedling-line",
    title: "发展理念",
    desc: "速度与准确很难同时拉满，我们的选择是先确认再提速。一条信息慢半天发布，好过让读者基于错误前提讨论一整天。",
  },
  {
    icon: "ri-book-open-line",
    title: "内容原则",
    desc: "给当事人留回应位，给未核实信息留标记，给判断失误留更正入口。这三条构成了我们所有内容处理的底线。",
  },
];

export default function AboutIntro() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <p className="mb-3 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.22em] text-primary-600">
              <span className="block h-px w-7 bg-primary-500" aria-hidden="true" />
              品牌介绍
            </p>
            <h2 className="mb-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {siteInfo.name}是一个把「后续」当主线的团队
            </h2>
            <div className="mb-8 space-y-4">
              <p className="text-sm leading-loose text-foreground-700 md:text-base">
                我们成立于 {siteInfo.since} 年，最初只是几个人在互相转发同一个瓜的不同版本，后来发现真正缺的从来不是爆料，
                而是把碎片串起来的那条线。于是我们开始为每一条线索建立独立档案，把之后发生的每一次回应、澄清与反转都追加进去。
              </p>
              <p className="text-sm leading-loose text-foreground-700 md:text-base">
                编辑部规模不大，因此我们对选题非常克制。同一条线索，我们宁可只写三句话，也不会用推测把篇幅撑满。
                读者打开一条记录，看到的应该是什么已经确认、什么还在求证，而不是一堆需要自己判断真伪的形容词。
              </p>
              <p className="text-sm leading-loose text-foreground-700 md:text-base">
                这里没有「最新消息」式的滚动刷屏，只有一条条可以被读完的时间线。如果你也厌倦了被半截信息牵着走，
                这里的工作方式应该适合你。
              </p>
            </div>

            <div className="flex flex-col gap-3">
              {POSITIONING.map((item) => (
                <div
                  key={item.title}
                  className="flex gap-4 rounded-lg border border-background-300 bg-background-50 p-4 md:p-5"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <div className="min-w-0">
                    <h3 className="mb-1 font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-background-300">
              <div className="h-[260px] w-full bg-background-200 md:h-[340px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Calm%20editorial%20workspace%20scene%20with%20a%20warm%20desk%20lamp%2C%20stacked%20notebooks%2C%20a%20wall%20of%20pinned%20blank%20note%20cards%20connected%20by%20red%20string%2C%20soft%20late%20afternoon%20light%2C%20no%20people%2C%20cinematic%20documentary%20mood&width=900&height=760&seq=hg-about-desk&orientation=landscape"
                  alt="黑瓜爆料编辑部用于梳理事件时间线的整理墙"
                  title="黑瓜爆料 编辑部 事件时间线整理"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="bg-background-100 p-5">
                <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-300 bg-background-300">
                  {siteInfo.stats.map((stat) => (
                    <div key={stat.label} className="bg-background-50 p-3.5">
                      <p className="mb-1 font-heading text-xl font-bold tabular-nums text-primary-600 md:text-2xl">
                        {stat.value}
                      </p>
                      <p className="font-label text-xs text-foreground-600">{stat.label}</p>
                    </div>
                  ))}
                </div>
                <p className="mt-3 font-label text-xs text-foreground-500">
                  数据统计自 {siteInfo.since} 年至今的全部公开追踪记录
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}